import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Empty } from '../components/ui';

export default function NotFoundPage() {
  return (
    <div className="page">
      <Empty icon={<Compass />} title="This page is not available" action={<Link to="/" className="btn">Go to the dashboard</Link>}>
        The link may be wrong, or the record belongs to someone else.
      </Empty>
    </div>
  );
}
